import Page from "@/components/layout/Page";

export default function Charities() {
  return (
    <div className="min-h-screen overflow-hidden bg-gradient-to-b from-[#020817] via-[#04151F] to-[#020817] text-slate-50">
      <Page>
        <section className="w-full pb-24">
          <div className="max-w-[1280px] mx-auto px-6">
          <h1 className="text-[54px] leading-[1.1] font-bold mb-6 page-title-gradient">Charities</h1>
          
          <div className="space-y-6 max-w-3xl">
            <p className="text-xl text-muted-foreground leading-relaxed">
              Partner with us to provide sensory support through charitable organizations and initiatives.
            </p>
            
            <p className="text-lg leading-relaxed">
              Samboards works with charities across the UK to ensure sensory support reaches those who need it most. We partner with organisations supporting brain injury survivors, autism charities, dementia support groups, and mental health charities to provide our products where they can make the greatest difference.
            </p>
            
            <p className="text-lg leading-relaxed">
              We're committed to making our products accessible to charitable organisations and community groups. Whether you're running support groups, day centres, or community programmes, we can work with you to provide sensory tools that support your beneficiaries' wellbeing.
            </p>
            
            <p className="text-lg leading-relaxed">
              Our donation programme has helped charities across the country provide sensory support to vulnerable individuals and families. We understand the vital role that charities play in supporting people with additional needs and are proud to contribute to this important work.
            </p>
            
            <p className="text-lg leading-relaxed">
              If you're a charity interested in partnering with Samboards or learning more about our charity support programme, please get in touch to discuss how we can work together.
            </p>
          </div>
        </div>
      </section>
      </Page>
    </div>
  );
}
